import { defineComponent as _defineComponent } from 'vue';
import { storeToRefs } from "pinia";
import { computed } from "vue";
import invocationsGridConfig from "@/components/Grid/configs/invocations";
import invocationsHistoryGridConfig from "@/components/Grid/configs/invocationsHistory";
import invocationsWorkflowGridConfig from "@/components/Grid/configs/invocationsWorkflow";
import { useUserStore } from "@/stores/userStore";
import Heading from "../Common/Heading.vue";
import UtcDate from "../UtcDate.vue";
import WorkflowInvocationState from "../WorkflowInvocationState/WorkflowInvocationState.vue";
import GridList from "@/components/Grid/GridList.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'GridInvocation',
    props: {
        noInvocationsMessage: { default: "No Workflow Invocations to display" },
        headerMessage: { default: "" },
        ownerGrid: { type: Boolean, default: true },
        filteredFor: { default: undefined }
    },
    setup(__props) {
        const props = __props;
        const { currentUser } = storeToRefs(useUserStore());
        const forStoredWorkflow = computed(() => { var _a; return ((_a = props.filteredFor) === null || _a === void 0 ? void 0 : _a.type) === "StoredWorkflow"; });
        const forHistory = computed(() => { var _a; return ((_a = props.filteredFor) === null || _a === void 0 ? void 0 : _a.type) === "History"; });
        const effectiveNoInvocationsMessage = computed(() => {
            var _a;
            let message = props.noInvocationsMessage;
            if (props.filteredFor) {
                message += ` for ${(_a = props.filteredFor) === null || _a === void 0 ? void 0 : _a.name}`;
            }
            return message;
        });
        const effectiveTitle = computed(() => {
            var _a, _b;
            let retVal = `Workflow Invocations`;
            const type = ((_a = props.filteredFor) === null || _a === void 0 ? void 0 : _a.type) === "StoredWorkflow" ? "Workflow" : "History";
            if (props.filteredFor && ((_b = props.filteredFor) === null || _b === void 0 ? void 0 : _b.name)) {
                retVal += ` for ${type} "${props.filteredFor.name}"`;
            }
            return retVal;
        });
        const extraProps = computed(() => {
            var _a, _b, _c, _d;
            const params = {};
            if (forStoredWorkflow.value) {
                params.workflow_id = (_a = props.filteredFor) === null || _a === void 0 ? void 0 : _a.id;
            }
            if (forHistory.value) {
                params.history_id = (_b = props.filteredFor) === null || _b === void 0 ? void 0 : _b.id;
            }
            if (!props.ownerGrid) {
                params.include_terminal = false;
            }
            else if (currentUser.value && !((_c = currentUser.value) === null || _c === void 0 ? void 0 : _c.isAnonymous)) {
                params.user_id = (_d = currentUser.value) === null || _d === void 0 ? void 0 : _d.id;
            }
            return params;
        });
        let gridConfig;
        if (forStoredWorkflow.value) {
            gridConfig = invocationsWorkflowGridConfig;
        }
        else if (forHistory.value) {
            gridConfig = invocationsHistoryGridConfig;
        }
        else {
            gridConfig = invocationsGridConfig;
        }
        function refreshTable() {
            // TODO: Implement
        }
        return { __sfc: true, props, currentUser, forStoredWorkflow, forHistory, effectiveNoInvocationsMessage, effectiveTitle, extraProps, gridConfig, refreshTable, Heading, UtcDate, WorkflowInvocationState, GridList };
    }
});
